import { ModuleWindowStore } from "./ModuleStores/ModuleWindowStore";
import { ModulesStore } from "./ModuleStores/ModulesStore";
import { action, makeObservable, observable } from "mobx";
import { IllustrationStore } from "./IllustrationStore";
import { IllustrationsStore } from "./IllustrationsStore";
import { NewsItemStore } from "./NewsItemStore";
import NewsStore from "./NewsStore";
import { TagsStore } from "./TagStore";
import { TaskStore } from "./TaskStore";
import { TasksStore } from "./TasksStore";
import { UserStore } from "./UserStore";
import { UsersStore } from "./UsersStore";
import { MainWindowStore } from "./MainPageStore";
import { AuthStore } from "./AuthStore";
import { RegistrationStore } from "./RegistrationStore";
import { UserLoginStore } from "./UserLoginStore";
import { AccessStore } from "./AccessStore";
import { ResourcesStore } from "./ResourcesStore";
import { ResourceStore } from "./ResourceStore";
import { LearningPathWindowStore } from "./LearningPathStores/LearningPathWindowStore";
import { GroupsStore } from "./GroupsStore";
import { GroupStore } from "./GroupStore";
import { GroupWindowStore } from "./GroupStores/GroupWindowStore";
import { GroupLearningPathWindowStore } from "./GroupStores/GroupLearningPathWindowStore";

export interface AppStoreApi {
  moduleWindowStore: ModuleWindowStore;
  modulesStore: ModulesStore;
  authStore: AuthStore;
  mainWindowStore: MainWindowStore;
  newsItemStore: NewsItemStore;
  newsStore: NewsStore;
  tagsStore: TagsStore;
  tasksStore: TasksStore;
  taskStore: TaskStore;
  usersStore: UsersStore;
  userStore: UserStore;
  registrationStore: RegistrationStore;
  loginStore: UserLoginStore;
  accessStore: AccessStore;
  illustrationStore: IllustrationStore;
  illustrationsStore: IllustrationsStore;
  resourcesStore: ResourcesStore;
  resourceStore: ResourceStore;
  learningPathWindowStore: LearningPathWindowStore;
  groupsStore: GroupsStore;
  groupStore: GroupStore;
  groupWindowStore: GroupWindowStore;
  groupLearningPathWindowStore: GroupLearningPathWindowStore;

  lastRequestTime: number;
}

class AppStoreImpl implements AppStoreApi {
  moduleWindowStore: ModuleWindowStore;
  modulesStore: ModulesStore;
  authStore: AuthStore;
  mainWindowStore: MainWindowStore;
  newsItemStore: NewsItemStore;
  newsStore: NewsStore;
  tagsStore: TagsStore;
  tasksStore: TasksStore;
  taskStore: TaskStore;
  usersStore: UsersStore;
  userStore: UserStore;
  registrationStore: RegistrationStore;
  loginStore: UserLoginStore;
  accessStore: AccessStore;
  illustrationStore: IllustrationStore;
  illustrationsStore: IllustrationsStore;
  resourcesStore: ResourcesStore;
  resourceStore: ResourceStore;
  learningPathWindowStore: LearningPathWindowStore;
  groupsStore: GroupsStore;
  groupStore: GroupStore;
  groupWindowStore: GroupWindowStore;
  groupLearningPathWindowStore: GroupLearningPathWindowStore;

  lastRequestTime = Date.now();

  constructor() {
    this.moduleWindowStore = new ModuleWindowStore();
    this.modulesStore = new ModulesStore();
    this.authStore = new AuthStore(this);
    this.mainWindowStore = new MainWindowStore(this);
    this.newsItemStore = new NewsItemStore();
    this.newsStore = new NewsStore();
    this.tagsStore = new TagsStore();
    this.tasksStore = new TasksStore();
    this.taskStore = new TaskStore();
    this.usersStore = new UsersStore();
    this.userStore = new UserStore(this);
    this.registrationStore = new RegistrationStore();
    this.loginStore = new UserLoginStore(this);
    this.accessStore = new AccessStore();
    this.illustrationStore = new IllustrationStore();
    this.illustrationsStore = new IllustrationsStore();
    this.resourcesStore = new ResourcesStore();
    this.resourceStore = new ResourceStore();
    this.learningPathWindowStore = new LearningPathWindowStore();
    this.groupsStore = new GroupsStore();
    this.groupStore = new GroupStore(this);
    this.groupWindowStore = new GroupWindowStore(this);
    this.groupLearningPathWindowStore = new GroupLearningPathWindowStore();

    makeObservable(this, {
      lastRequestTime: observable,
      updateLastRequestTime: action.bound,
    });
  }

  updateLastRequestTime = () => {
    this.lastRequestTime = Date.now();
  };
}

let appStore = new AppStoreImpl();

export default appStore;
